// The backend stamps the section complete at five strengths
// (save-clifton-strengths, get-portal-dashboard); the form counts the same way.
export const REQUIRED_CLIFTON_STRENGTHS = 5

export function cliftonStrengthsMissing(count: number): number {
  return Math.max(0, REQUIRED_CLIFTON_STRENGTHS - count)
}

export function portalCliftonStrengthsSummary(count: number): string {
  const missing = cliftonStrengthsMissing(count)
  if (missing === 0) {
    return `You have added ${count} Clifton Strengths. This section is complete.`
  }
  return `${count} of ${REQUIRED_CLIFTON_STRENGTHS} Clifton Strengths added. Add ${missing} more to complete this section.`
}
